export class Address {
	constructor(obj) {
		if (!obj) return;

		this.building_name = obj.building_name;
		this.country = obj.country;
		this.province = obj.province;
		this.street = obj.street;
		this.unit_no = obj.unit_no;
		this.suburb = obj.suburb;
		this.region = obj.region;
		this.postal_code = obj.postal_code;
	}
}

export default Address;
